var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_992_6501",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9402 2.14735C12.3737 1.26896 13.6263 1.26897 14.0598 2.14735L16.5456 7.18423C16.7178 7.53304 17.0505 7.7748 17.4355 7.83073L22.994 8.63844C23.9633 8.77929 24.3504 9.97053 23.649 10.6543L19.6268 14.5749C19.3482 14.8464 19.2211 15.2376 19.2869 15.621L20.2364 21.1571C20.402 22.1225 19.3887 22.8587 18.5217 22.4029L13.5499 19.7891C13.2057 19.6081 12.7943 19.6081 12.4501 19.7891L7.47835 22.4029C6.61133 22.8587 5.59801 22.1225 5.76359 21.1571L6.7131 15.621C6.77886 15.2376 6.65175 14.8464 6.37322 14.5749L2.35102 10.6543C1.64959 9.97053 2.03665 8.77929 3.006 8.63844L8.56453 7.83073C8.94946 7.7748 9.28222 7.53304 9.45437 7.18423L11.9402 2.14735Z",
    fill: "#FEAF3A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_992_6501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9402 2.14735C12.3737 1.26896 13.6263 1.26897 14.0598 2.14735L16.5456 7.18423C16.7178 7.53304 17.0505 7.7748 17.4355 7.83073L22.994 8.63844C23.9633 8.77929 24.3504 9.97053 23.649 10.6543L19.6268 14.5749C19.3482 14.8464 19.2211 15.2376 19.2869 15.621L20.2364 21.1571C20.402 22.1225 19.3887 22.8587 18.5217 22.4029L13.5499 19.7891C13.2057 19.6081 12.7943 19.6081 12.4501 19.7891L7.47835 22.4029C6.61133 22.8587 5.59801 22.1225 5.76359 21.1571L6.7131 15.621C6.77886 15.2376 6.65175 14.8464 6.37322 14.5749L2.35102 10.6543C1.64959 9.97053 2.03665 8.77929 3.006 8.63844L8.56453 7.83073C8.94946 7.7748 9.28222 7.53304 9.45437 7.18423L11.9402 2.14735Z",
    fill: "#FEAF3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 1.18188,
    width: 11.8182,
    height: 22.4545,
    fill: "#F7EBD8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStart);
export default __webpack_public_path__ + "static/media/half-start.1300a55099081a0b90dc69ecc35be28e.svg";
export { ForwardRef as ReactComponent };